import Cookies from 'js-cookie'

/**
 * 全局回车搜索功能工具
 * 使用方法：
 * 1. 在组件中引入：import { useEnterSearch } from '../../../util/enterSearch'
 * 2. 在 mounted 中调用：useEnterSearch(this.handleSearch)
 * 3. 在 beforeDestroy 中调用：removeEnterSearch()
 */

let currentCallback = null;

/**
 * 添加全局回车监听
 * @param {Function} callback - 回车时要执行的回调函数
 * @param {Object} options - 可选配置
 * @param {string} options.condition - 执行条件函数名
 */
export function useEnterSearch(callback, options = {}) {
  const handleGlobalEnter = (event) => {
    if (event.key === 'Enter') {
      // 如果有条件判断，则先检查条件
      if (options.condition && typeof options.condition === 'string') {
        const conditionResult = evaluateCondition(options.condition);
        if (!conditionResult) return;
      }
      
      // 执行回调函数
      if (typeof callback === 'function') {
        callback();
      }
    }
  };

  // 移除之前的监听器
  if (currentCallback) {
    document.removeEventListener('keydown', currentCallback);
  }

  // 添加新的监听器
  document.addEventListener('keydown', handleGlobalEnter);
  currentCallback = handleGlobalEnter;
}

/**
 * 移除全局回车监听
 */
export function removeEnterSearch() {
  if (currentCallback) {
    document.removeEventListener('keydown', currentCallback);
    currentCallback = null;
  }
}

/**
 * 评估条件表达式
 * @param {string} condition - 条件表达式
 * @returns {boolean} - 条件结果
 */
function evaluateCondition(condition) {
  // 从 Cookie 中获取当前激活的标签页
  const activeTab = Cookies.get('activeTab');
  
  // 简单的条件匹配
  if (condition.includes('activeTab')) {
    const expectedTab = condition.split('===')[1]?.trim().replace(/['"]/g, '');
    return activeTab === expectedTab;
  }
  
  return true;
}

/**
 * 预定义的常用条件
 */
export const SEARCH_CONDITIONS = {
  WALLET_STAT: "activeTab === 'stat'",
  WALLET_DETAIL: "activeTab === 'detail'",
  ORDER_LIST: "activeTab === 'order'",
  USER_LIST: "activeTab === 'user'"
};

// 默认导出
export default {
  useEnterSearch,
  removeEnterSearch,
  SEARCH_CONDITIONS
};